import { cn } from '@/services/utils';

const DialogHeader = ({
    className,
    ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
    <div
        className={cn(
            `scoped-dialog-header
             tw-items-center
             tw-flex-shrink-0
             tw-py-3
             tw-px-5
             tw-bg-fill-primary
             tw-rounded-t-lg
             tw-border-l-0
             tw-border-r-0
             tw-border-t-0
             tw-border-b
             tw-border-solid
             tw-border-tertiary
             lg:tw-px-8`,
            className
        )}
        {...props}
    />
);

DialogHeader.displayName = 'DialogHeader';

export { DialogHeader };
